import { ArrowLeftIcon } from '@/components/icons'
import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import classes from './styles.module.scss'

interface MenuHeaderProps {
  title: string
  onBack?: (event: any) => void
}

const DiscoverHeader = ({ title, onBack }: MenuHeaderProps) => {
  return (
    <Stack
      sx={{
        backgroundColor: 'background.overrideDefault',
      }}
      className={classes.root}
    >
      <Stack className={classes.leftBox} direction="row" spacing="10px">
        <Box>
          <Button
            variant="secondary"
            className={classes.btnBack}
            onClick={onBack}
          >
            <ArrowLeftIcon />
          </Button>
        </Box>
        <Box>
          <Grid>
            <Typography className={classes.subTitle}>Data Discovery</Typography>
          </Grid>
          <Grid>
            <Typography className={classes.title}>{title}</Typography>
          </Grid>
        </Box>
      </Stack>
    </Stack>
  )
}

export default DiscoverHeader
